import { ref } from 'vue';
import { useApi } from '@/composables/use-api';
import homeService from '@/service/home';

export const useLiveList = (initialData: any[]) => {
  const liveList = ref(initialData);
  const hasMore = ref(true);
  let cursor = 1;
  const getLiveList = async () => {
    const { data } = await homeService.getLiveIndex(cursor);
    cursor++;
    const { live_list } = data;
    liveList.value = liveList.value.concat(live_list || []);
    hasMore.value = data.has_more;
    return data;
  };

  const { loading, error, result, fetchApi, } = useApi(getLiveList);

  return {
    loading,
    error,
    result,
    fetchLiveList: fetchApi,
    liveList,
    hasMore
  };
};

